import{ FiThumbsUp, FiMessageCircle, FiSearch } from'react-icons/fi'

export const AboutCompany = () => {
    return (
        <div className="about-page mb-3">
            <div>
                <h4 className="big">About</h4>
                <div> <p>All</p></div>
            </div>
            <ul>
                <li>
                    <div>
                        <FiThumbsUp className="icon thumbsup" />
                        <p>1,350,692 people like this, including 24 of your friends</p>
                    </div>
                </li>
                <li>
                    <div>
                        <div className="people">
                            <img src="/assets/images/faces/1.png" className="person" alt="" />
                            <img src="/assets/images/faces/2.png" className="person" alt="" />
                            <img src="/assets/images/faces/3.png" className="person" alt="" />
                            <img src="/assets/images/faces/4.png" className="person" alt="" />
                            <img src="/assets/images/faces/5.png" className="person" alt="" />
                            <img src="/assets/images/faces/6.png" className="person" alt="" />
                            <img src="/assets/images/faces/7.png" className="person" alt="" />
                            <img src="/assets/images/faces/8.png" className="person" alt="" />
                            <img src="/assets/images/faces/9.png" className="person" alt="" />
                            <img src="/assets/images/faces/0.png" className="person" alt="" />
                            <img src="/assets/images/faces/1.png" className="person" alt="" />
                            <img src="/assets/images/faces/2.png" className="person" alt="" />
                            <img src="/assets/images/faces/3.png" className="person" alt="" />

                        </div>
                    </div>
                </li>
                <li>
                    <div>
                        <FiSearch className="icon" />
                        <p>1,380,456 people follow this</p>
                    </div>
                </li>
                <li>
                    <div>
                        <FiMessageCircle className="icon" />
                        <p> Message </p>
                    </div>
                </li>

            </ul>
        </div>
    )
}